/* eslint-disable react/jsx-props-no-spreading */
import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import { Account } from '../../variables/types';
import { getAccountById, getAccountName } from './common';
import { AutocompleteBox, AutoCompleteTextField } from '../AutoComplete';
import { useAccountProvider } from '../../core/accountContext';
import COLORS from '../../variables/colors';

interface Props {
  error?: boolean;
  className: string;
  defaultValue: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const useStyles = makeStyles(() => createStyles({
  error: {
    border: `1px solid ${COLORS.violet}`,
  },
}));

const ExpenseAccountMenu = ({
  error,
  className,
  value,
  onChange,
}: Props) => {
  const classes = useStyles();
  const { account: { accountIncomes } } = useAccountProvider();
  const selectedAccount = getAccountById(value, accountIncomes);
  const onSelectChange = (_: any, accountIncome: any) => {
    onChange(accountIncome?.id);
  };
  return (
    <AutocompleteBox
      className={clsx(className, { [classes.error]: Boolean(error) })}
      options={accountIncomes as Account[] ?? []}
      getOptionLabel={(option: any) => getAccountName(option!)}
      onChange={onSelectChange}
      value={selectedAccount ?? ''}
      openOnFocus
      renderInput={(params) => (
        <AutoCompleteTextField
          {...params}
          hiddenLabel
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
          }}
        />
      )}
    />
  );
};

export default React.memo(ExpenseAccountMenu);
